// extracted by mini-css-extract-plugin
module.exports = {"transparent-box":"EditedVersion_transparent-box__POcK9"};